// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__RHVke","dark-wrapper":"style_dark-wrapper__4QUIX","copy-button":"style_copy-button__7g0b0"};